/*
  DATOS COMERCIALES
  Todo campo vacío aparece en la página como "Pending" para que nada quede inventado.
  - price / previousPrice: solo números. El ahorro se calcula solo si están ambos.
  - checkoutUrl: link real de pago (https).
*/
export const offer = {
  brand: 'Speech Therapy Ready',
  packageName: 'Fall Starter Kit — Complete Package',
  packageSummary: '3 complete units + 5 bonuses · 100% PDF',
  price: '29',
  currency: 'USD',
  previousPrice: '',
  paymentMode: '',
  checkoutUrl: 'https://speech-therapy-ready.impultienda.ar/checkout',
  accessDuration: '',
  guaranteeDays: '10',
  guaranteeTerms:
    'Try the full kit for 10 days. If it isn’t right for you, we’ll refund your money — no hassle, no questions asked.',
  paymentMethods: [] as string[],
  paymentNote: 'Price shown in USD — you pay the equivalent in your local currency.',
  contactEmail: '',
  socialLinks: [] as { label: string; href: string }[],
  legalLinks: [] as { label: string; href: string }[],
};
